import React from 'react';
import { CircleDashed } from 'lucide-react';
export const Footer: React.FC = () => {
  return <footer className="bg-primary text-surface pt-20 pb-10 border-t border-surface/10" data-id="element-186">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-187">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-12 mb-16" data-id="element-188">
          <div className="col-span-2" data-id="element-189">
            <div className="flex items-center gap-2 text-white mb-6" data-id="element-190">
              <CircleDashed className="w-6 h-6 text-leaf" data-id="element-191" />
              <span className="font-display font-semibold text-2xl tracking-tight" data-id="element-192">
                CycleBox
              </span>
            </div>
            <p className="text-white/60 max-w-sm leading-relaxed" data-id="element-193">
              Returnable packaging, reimagined as a service. We help operators
              replace single-use bottles, crates, and pallets with a smarter,
              circular system.
            </p>
          </div>

          <div data-id="element-194">
            <h4 className="font-mono text-sm text-leaf mb-6 uppercase tracking-widest" data-id="element-195">
              Product
            </h4>
            <ul className="space-y-4 text-surface/70" data-id="element-196">
              <li data-id="element-197">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-198">
                  How it works
                </a>
              </li>
              <li data-id="element-199">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-200">
                  Technology
                </a>
              </li>
              <li data-id="element-201">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-202">
                  Pricing
                </a>
              </li>
              <li data-id="element-203">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-204">
                  Impact Data
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-205">
            <h4 className="font-mono text-sm text-leaf mb-6 uppercase tracking-widest" data-id="element-206">
              Company
            </h4>
            <ul className="space-y-4 text-surface/70" data-id="element-207">
              <li data-id="element-208">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-209">
                  About Us
                </a>
              </li>
              <li data-id="element-210">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-211">
                  Careers
                </a>
              </li>
              <li data-id="element-212">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-213">
                  Blog
                </a>
              </li>
              <li data-id="element-214">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-215">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-216">
            <h4 className="font-mono text-sm text-leaf mb-6 uppercase tracking-widest" data-id="element-217">
              Legal
            </h4>
            <ul className="space-y-4 text-surface/70" data-id="element-218">
              <li data-id="element-219">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-220">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-221">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-222">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-223">
                <a href="#" className="hover:text-surface transition-colors" data-id="element-224">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-surface/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-surface/40" data-id="element-225">
          <p data-id="element-226">
            © {new Date().getFullYear()} CycleBox Inc. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-227">
            <a href="#" className="hover:text-surface transition-colors" data-id="element-228">
              Twitter
            </a>
            <a href="#" className="hover:text-surface transition-colors" data-id="element-229">
              LinkedIn
            </a>
            <a href="#" className="hover:text-surface transition-colors" data-id="element-230">
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>;
};